import { Injectable } from '@angular/core';
import { NotificationDataEntry } from '@osos/shared/api';
import { NotificationPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases/factory/factory-base';
import { NotificationParserV1Service } from '../../parsers/notification-parser/notification-parser-v1-service';
import { ParserFactory } from '../../services';

@Injectable({
  providedIn: 'root',
})
export class NotificationFactoryService extends FactoryBase<
  NotificationDataEntry,
  NotificationPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: NotificationParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(
    presenter: NotificationPresenterModel,
  ): NotificationDataEntry {
    throw new Error('Method not implemented.');
  }

  createPresenterModel(
    model: NotificationDataEntry,
  ): NotificationPresenterModel {
    const parser = this.getParser(
      NotificationDataEntry,
      NotificationPresenterModel,
      model.specificationVersion,
    );

    const result = parser.getPresenterModel(model);
    return result;
  }
}
